const PHONE_PART_LENGTH = 6

export const passwordContainsPhonePart = (password: string, phone: string) => {
  const passwordDigits = password.replace(/\D/g, '')
  const phoneDigits = phone.replace(/\D/g, '')

  for (
    let index = 0;
    index <= phoneDigits.length - PHONE_PART_LENGTH;
    index += 1
  ) {
    if (
      passwordDigits.includes(
        phoneDigits.slice(index, index + PHONE_PART_LENGTH)
      )
    ) {
      return true
    }
  }

  return false
}
